import { createSelector } from "@reduxjs/toolkit"

export const selectTasks = (state) => state.tasks.tasks

export const selectPointsTasks = (state) => state.tasks.pointsTasks

export const selectTasksPoints = createSelector(
    [selectTasks],
    (tasks) => {
        const pointsTasks = tasks.filter(t => t.type === 'points').sort((a, b) => a.id - b.id)
        return pointsTasks
    }
)

export const selectTasksByObject = createSelector(
    [selectTasksPoints, (state, type, id) => type, (state, type, id) => id],
    (pointsTasks, type, id) => {
        if (!pointsTasks || !type || !id) return undefined;
        const task = pointsTasks.find(pt => pt?.data?.objects?.[type]?.includes(id))
        if (!task) return undefined;
        return {
            ...task,
            statusCurrent: task.data?.statuses?.[`${type}_${id}`] || task.status,
            reasonCurrent: task.data?.reasons?.[`${type}_${id}`]
        }
    }
)

